module.exports = __webpack_public_path__ + "img/profile-question.36b4266b.svg";